import { render, staticRenderFns } from "./LocalEventoView.vue?vue&type=template&id=542e0272&scoped=true"
import script from "./LocalEventoView.vue?vue&type=script&lang=js"
export * from "./LocalEventoView.vue?vue&type=script&lang=js"
import style0 from "./LocalEventoView.vue?vue&type=style&index=0&id=542e0272&prod&lang=scss&scoped=true"
import style1 from "./../../../../../components/editor/style-editor.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e0272",
  null
  
)

export default component.exports